import { api } from '@helpers/api'
import { IProduct } from '@/types/IProduct'

export const fetchProductData = async (): Promise<IProduct> => {
  return api.get('/product')
    .then(response => {
      const productContainer = response.data?.data?.[0] ?? response.data
      return productContainer
    })
}

